const React = require('react');
const withState = require('../../../../../../../../utils/withState');
const WrapperWithLoading = require('../../../../../../../dumb/WrapperWithLoading');

const Item = ({title, dataKey, data}) => {
  const value = data[dataKey] || '-';
  return (
    <div className="layoutRow aiC f12 c0">
      <span className="dB fw3 mr6">{`${title}:`}</span>
      <span className="dB fw7">{value}</span>
    </div>
  )
}

module.exports = withState((setState, self, onMount) => {
  self.state = {
    ...self.state,
    data: {},
    loading: true
  }

  onMount(() => {
    const request = self.props.request;

    if (!request) {
      setState({loading: false});
      return;
    }

    request().then((data) => setState({data, loading: false}))
  });

  return ({loading, data}, {display = []}) => {
    return (
      <WrapperWithLoading loading={loading}>
        {!!display.length && (
          <div className="layoutRow aiC dB@m4">
            {display.map((el) => (
              <div key={el.dataKey} className="mr20 mt20@m4">
                <Item {...el} data={data} />
              </div>
            ))}
          </div>
        )}
      </WrapperWithLoading>
    )
  }
})
